import {Injectable} from '@angular/core';
import {SCA_VALIDATION_RESPONSE_PATH} from "@core/shared/data/sca";

@Injectable({
    providedIn: 'root'
})
export class ScaService {

    constructor() {}

    public getValidationResponseUrl(locale: string): string {

        return `${window.location.origin}/${locale}${SCA_VALIDATION_RESPONSE_PATH}`;
    }
}
